import { html } from "htm/preact";
import { configureInstance } from "@pagefind/component-ui";

export const initPagefind = async () => {
  try {
    // console.log("Loading Pagefind...");
    configureInstance("opcl-instance", {
      indexWeight: 2,
      mergeIndex: [
        {
          bundlePath: "https://data.openers-closers.com/pagefind",
          indexWeight: 0.1,
        },
        {
          bundlePath: "https://manuals.openers-closers.com/pagefind",
          indexWeight: 0.1,
        },
      ],
      ranking: {
        //termFrequency: 0.5,
        //pageLength: 1.0,
        //title: 10.0,
        //termSimilarity: 1.0,
        metaWeights: {
          title: 10.0
        }
      },
    });
    // console.log("Pagefind loaded.");
  } catch (e) {
    console.error("Error loading Pagefind:", e);
  }
};


// Search Trigger (Button Search)
export default function SearchTrigger({ searchLabel }) {
  const handleOpenSearch = (e) => {
    e.preventDefault();

    const modalPagefind = document.getElementById("opcl-search-modal");

    if (!modalPagefind) {
      console.warn("ERROR: Pagefind modal not found");
      return;
    }

    if (typeof modalPagefind.open === "function") {
      modalPagefind.open();
    } else {
      modalPagefind.setAttribute("open", "");
    }
  };
  return html`
    <button
      onClick=${handleOpenSearch}
      type="button"
      aria-label=${searchLabel}
      class="relative text-base p-3 lg:p-3 flex items-center gap-1 rounded-lg
      border border-transparent bg-transparent
      group-data-hero/root:text-zinc-100 cursor-pointer
      group-data-nav-open:text-zinc-900
      group-data-nav-mobile-open:text-zinc-900
      group-data-hero-outside:text-zinc-900
      group-data-active:border-olive-300/30 group-data-active:bg-olive-300/20"
    >
      <span class="sr-only">${searchLabel}</span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        stroke-width="1"
        role="img"
        fill="none"
        class="size-4 stroke-current"
        aria-hidden="true"
      >
        <circle cx="9.543" cy="6.589" r="5.709" stroke="currentColor"></circle>
        <path stroke="currentColor" d="M6.051 10.524l-4.95 4.949"></path>
      </svg>
    </button>
  `;
}